import React from 'react';
import '../../styles/shared.css';

interface AdBlockTabProps {
    handleForm: any;
}

const AdBlockTab: React.FC<AdBlockTabProps> = ({ handleForm }) => {
    return (
        <div className="general-settings-container">
            <div className="settings-section">
                <h3 className="section-title" data-icon="⏱️">Configurações de Sessão</h3>

                <div className="row g-3">
                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label htmlFor="userSessionDurationHours" className="form-label">
                                Duração da Sessão (horas)
                                <span className="text-muted small d-block">Tempo em horas para considerar uma sessão ativa</span>
                            </label>
                            <input
                                type="number"
                                id="userSessionDurationHours"
                                name="userSessionDurationHours"
                                className={`form-control ${handleForm.touched.userSessionDurationHours && handleForm.errors.userSessionDurationHours ? 'error' : ''}`}
                                onChange={handleForm.handleChange}
                                onBlur={handleForm.handleBlur}
                                value={handleForm.values.userSessionDurationHours}
                                min="1"
                                max="720"
                                placeholder="12"
                            />
                            {handleForm.touched.userSessionDurationHours && handleForm.errors.userSessionDurationHours ? (
                                <div className="invalid-feedback d-block">{handleForm.errors.userSessionDurationHours}</div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>

            <div className="settings-section">
                <h3 className="section-title" data-icon="🛡️">Configurações do AdBlock Detection</h3>
                <p className="section-description">
                    Configure as mensagens e comportamento quando um bloqueador de anúncios for detectado.
                </p>

                <div className="row g-3">
                    <div className="col-12">
                        <div className="form-group">
                            <label htmlFor="adBlockConfig.title" className="form-label">
                                Título do Modal
                                <span className="text-muted small d-block">Título exibido no modal de detecção de AdBlock</span>
                            </label>
                            <input
                                type="text"
                                id="adBlockConfig.title"
                                name="adBlockConfig.title"
                                className={`form-control ${handleForm.touched.adBlockConfig?.title && handleForm.errors.adBlockConfig?.title ? 'error' : ''}`}
                                onChange={handleForm.handleChange}
                                onBlur={handleForm.handleBlur}
                                value={handleForm.values.adBlockConfig?.title || ''}
                                placeholder="AdBlock Detectado"
                            />
                            {handleForm.touched.adBlockConfig?.title && handleForm.errors.adBlockConfig?.title ? (
                                <div className="invalid-feedback d-block">{handleForm.errors.adBlockConfig.title}</div>
                            ) : null}
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <label htmlFor="adBlockConfig.message" className="form-label">
                                Mensagem do Modal
                                <span className="text-muted small d-block">Mensagem explicativa para o usuário</span>
                            </label>
                            <textarea
                                id="adBlockConfig.message"
                                name="adBlockConfig.message"
                                className={`form-control ${handleForm.touched.adBlockConfig?.message && handleForm.errors.adBlockConfig?.message ? 'error' : ''}`}
                                rows={4}
                                onChange={handleForm.handleChange}
                                onBlur={handleForm.handleBlur}
                                value={handleForm.values.adBlockConfig?.message || ''}
                                placeholder="Detectamos que você está usando um bloqueador de anúncios. Para continuar navegando, por favor desative o bloqueador ou adicione nosso site à lista de exceções."
                            />
                            {handleForm.touched.adBlockConfig?.message && handleForm.errors.adBlockConfig?.message ? (
                                <div className="invalid-feedback d-block">{handleForm.errors.adBlockConfig.message}</div>
                            ) : null}
                        </div>

                        <div className="col-12 col-md-6">
                            <label htmlFor="adBlockConfig.reloadText" className="form-label">
                                Texto do Botão
                                <span className="text-muted small d-block">Texto exibido no botão de fechar/recarregar</span>
                            </label>
                            <input
                                type="text"
                                id="adBlockConfig.reloadText"
                                name="adBlockConfig.reloadText"
                                className={`form-control ${handleForm.touched.adBlockConfig?.reloadText && handleForm.errors.adBlockConfig?.reloadText ? 'error' : ''}`}
                                onChange={handleForm.handleChange}
                                onBlur={handleForm.handleBlur}
                                value={handleForm.values.adBlockConfig?.reloadText || ''}
                                placeholder="Recarregar Página"
                            />
                            {handleForm.touched.adBlockConfig?.reloadText && handleForm.errors.adBlockConfig?.reloadText ? (
                                <div className="invalid-feedback d-block">{handleForm.errors.adBlockConfig.reloadText}</div>
                            ) : null}
                        </div>
                    </div>

                    <div className="mb-3">
                        <div className="form-group">
                            <label htmlFor="adBlockConfig.allowClose" className="form-label">
                                Permitir Acesso à Página
                                <span className="text-muted small d-block">Permite que o usuário feche o modal e continue navegando</span>
                            </label>
                            <select
                                id="adBlockConfig.allowClose"
                                name="adBlockConfig.allowClose"
                                className={`form-select ${handleForm.touched.adBlockConfig?.allowClose && handleForm.errors.adBlockConfig?.allowClose ? 'error' : ''}`}
                                onChange={handleForm.handleChange}
                                onBlur={handleForm.handleBlur}
                                value={handleForm.values.adBlockConfig?.allowClose || 'true'}
                            >
                                <option value="true">✅ Sim - Usuário pode fechar o modal</option>
                                <option value="false">❌ Não - Modal não pode ser fechado</option>
                            </select>
                            {handleForm.touched.adBlockConfig?.allowClose && handleForm.errors.adBlockConfig?.allowClose ? (
                                <div className="invalid-feedback d-block">{handleForm.errors.adBlockConfig.allowClose}</div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>

            <div className="settings-section">
                <h3 className="section-title">💡 Exemplo de Configuração</h3>
                <div className="example-card">
                    <div className="example-header">
                        <strong>Preview da Configuração:</strong>
                    </div>
                    <div className="example-content">
                        <div className="mock-modal">
                            <div className="mock-modal-header">
                                <h4>{handleForm.values.adBlockConfig?.title || 'AdBlock Detectado'}</h4>
                            </div>
                            <div className="mock-modal-body">
                                <p>{handleForm.values.adBlockConfig?.message || 'Detectamos que você está usando um bloqueador de anúncios. Para continuar navegando, por favor desative o bloqueador ou adicione nosso site à lista de exceções.'}</p>
                            </div>
                            <div className="mock-modal-footer">
                                <button className="mock-button">
                                    {handleForm.values.adBlockConfig?.reloadText || 'Recarregar Página'}
                                </button>
                                {(handleForm.values.adBlockConfig?.allowClose === 'true' || handleForm.values.adBlockConfig?.allowClose === true) && (
                                    <button className="mock-button-secondary">Fechar</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdBlockTab;